import { PARAM_STATUS_META } from '@/shared/ui/paramStatusMeta';

/**
 * Maps a live parameter value row to its status meta (color/bg/border) for the
 * diagram panel. Returns null when there is no reading, so the UI shows a
 * neutral "—" rather than a colored chip.
 *
 * @param {{ value?: number|null, state?: string }|undefined} live
 */
export function liveMeta(live) {
  if (!live || live.value == null) return null;
  return PARAM_STATUS_META[live.state] ?? null;
}
